import _ from 'lodash'

import {BuildConfigurationInput} from '../types'

import {buildLoadBalanceConfiguration} from './loadBalance/buildLoadBalanceConfiguration'
import {buildConfirmationPinConfiguration} from './confirmationPin/buildConfirmationPinConfiguration'
import {buildDateTimeConfiguration} from './dateTime/buildDateTimeConfiguration'
import {buildIsConfirmedConfiguration} from './isConfirmed/buildIsConfirmedConfiguration'
import {buildLoadSpacingConfiguration} from './loadSpacing/buildLoadSpacingConfiguration'
import {buildMixConfiguration} from './mix/buildMixConfiguration'
import {buildMixCharacteristicsConfiguration} from './mixCharacteristics/buildMixCharacteristicsConfiguration'
import {buildFullLoadConfiguration} from './fullLoad/buildFullLoadConfiguration'
import {buildPlusLoadConfiguration} from './plusLoad/buildPlusLoadConfiguration'
import {buildQuantityConfiguration} from './quantity/buildQuantityConfiguration'
import {buildRetarderConfiguration} from './retarder/buildRetarderConfiguration'
import {buildIsTestBookedConfiguration} from './testing/buildIsTestBookedConfiguration'
import {
  buildAdditionalNotesConfiguration,
  buildDriverInstructionsConfiguration,
  buildPoNumberConfiguration
} from './textField'
import {buildTruckConfiguration} from './trucks/buildTruckConfiguration'
import {FieldsConfiguration} from './types'
import {buildUnloadingMethodConfiguration} from './unloadingMethod/buildUnloadingMethodConfiguration'
import {buildUsageConfiguration} from './usage/buildUsageConfiguration'

export const buildConfiguration = (input: BuildConfigurationInput): FieldsConfiguration => {
  return _.merge(
    buildIsConfirmedConfiguration(input),
    buildConfirmationPinConfiguration(input),
    buildQuantityConfiguration(input),
    buildFullLoadConfiguration(input),
    buildPlusLoadConfiguration(input),
    buildLoadBalanceConfiguration(input),
    buildTruckConfiguration(input),
    buildLoadSpacingConfiguration(input),
    buildRetarderConfiguration(input),
    buildDateTimeConfiguration(input),
    buildMixConfiguration(input),
    buildMixCharacteristicsConfiguration(input),
    buildAdditionalNotesConfiguration(input),
    buildDriverInstructionsConfiguration(input),
    buildPoNumberConfiguration(input),
    buildUnloadingMethodConfiguration(input),
    buildUsageConfiguration(input),
    buildIsTestBookedConfiguration(input)
  )
}
